export default __webpack_public_path__ + "static/media/Rae_9781408349632.9cc0b623.jpg";